/* eslint-disable camelcase */
import {
  retrieveCartEntity,
  changeCartEntity,
  clearCartEntity,
  retrieveCartInfo,
} from '@api/cart.service'

import sendStatusCart from '@/js/analytics/cart'

const SET_CART = 'SET_CART'
const SET_CART_INFO = 'SET_CART_INFO'

export function createStore() {
  return {
    namespaced: true,
    state: {
      cart: [{
        groups: [],
      }],
      cart_info: {
        quantity: 0,
        total_price: 0,
      },
      isCartLoading: true,
      isEmpty: true,
    },
    getters: {
      getCartByShop: state => id => {
        const SINGLE_SHOP_CART = 1
        if (state.cart.length === SINGLE_SHOP_CART) {
          const [first] = state.cart
          return [first]
        }
        // eslint-disable-next-line eqeqeq
        return state.cart.filter(({ shop: { id: shopId } }) => shopId == id)
      },
    },
    actions: {
      async getCart({ commit, state }) {
        state.isCartLoading = true
        const { data } = (await retrieveCartEntity.execute())
        state.isCartLoading = false
        commit(SET_CART, { payload: data }, false)
      },
      async changeCart({ commit, state }, payload) {
        state.isCartLoading = true
        return changeCartEntity.execute({}, payload)
          .then(async ({ data }) => {
            state.isCartLoading = false
            commit(SET_CART, { payload: data, sendAnalytics: true })
            return data
          })
      },
      async clearCart({ commit, state }) {
        state.isCartLoading = true
        const { data } = (await clearCartEntity.execute())
        commit(SET_CART, { payload: data, sendAnalytics: true })
        state.isCartLoading = true
      },
      async getCartInfo({ commit, state }) {
        state.isCartLoading = true
        const { data } = (await retrieveCartInfo.execute())
        commit(SET_CART_INFO, data)
        state.isCartLoading = false
      },
    },
    mutations: {
      [SET_CART](state, { payload, sendAnalytics = false }) {
        state.cart = payload
        state.isEmpty = false
        if (sendAnalytics) sendStatusCart(payload)
        if (!state.cart.length) return
        const { quantity, total_price } = state.cart.reduce((acc, obj) => {
          acc.quantity += obj.quantity
          acc.total_price += obj.total_price
          return acc
        }, { quantity: 0, total_price: 0 })
        // state.cart_info.total_price = state.cart.total_price
        state.cart_info.quantity = quantity
        state.cart_info.total_price = total_price
      },
      [SET_CART_INFO](state, payload) {
        state.cart_info = payload
        window.cart_total = state.cart_info.total_price
      },
    },
  }
}
